import { isChatPath } from './isChatPath';

/**
 * Whether the page is somewhere the conversation's "Dock to side" should return
 * to. Home (and the chat pages) hold the conversation themselves, so docking it
 * next to them would only duplicate it.
 */
export function isDockTarget(pathname: string): boolean {
  return !isChatPath(pathname);
}
